import React from 'react';
import PropTypes from 'prop-types';
import styles from './CustomConfirmModal.module.css';

const CustomConfirmModal = ({
  show,
  title,
  content,
  confirmLabel,
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  confirmClassName = '',
  loading = false,
}) => {
  if (!show) return null;
  // No overlay onClick — dialogs must not close on an outside click (only the × / Cancel).
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>{title}</h2>
          <button
            className={styles.closeBtn}
            onClick={onCancel}
            aria-label="Close"
          >
            &times;
          </button>
        </div>
        <div className={styles.modalBody}>{content}</div>
        <div className={styles.modalFooter}>
          <button
            className={styles.btnSecondary}
            onClick={onCancel}
            disabled={loading}
          >
            {cancelLabel}
          </button>
          <button
            className={`${styles.btnPrimary} ${confirmClassName}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? 'Processing...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

CustomConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmLabel: PropTypes.string.isRequired,
  cancelLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  confirmClassName: PropTypes.string,
  loading: PropTypes.bool,
};

export default CustomConfirmModal;
